import axios from "src/lib/axios";

// Get all TISI
export const getTISIList = async (userId ) => {
  try {
    const response = await axios.get(`/tisis?user_id=${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching TISI list:", error);
    throw error;
  }
};

// Get TISI by ID
export const getTISIDetail = async (id) => {
  try {
    const response = await axios.get(`/tisi/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create new TISI
export const createTISI = async (data) => {
  try {
    const response = await axios.post("/tisi", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update TISI
export const updateTISI = async (id, data) => {
  try {
    const response = await axios.put(`/tisi/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete TISI
export const deleteTISI = async (id) => {
  try {
    const response = await axios.delete(`/tisi/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
